import { Component, Input } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { NgbTooltipModule, Placement } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'boels-product-one-call',
  templateUrl: './product-one-call.component.html',
  styleUrls: ['./product-one-call.component.scss'],
  imports: [TranslocoModule, FontAwesomeModule, NgbTooltipModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productDetails'],
    },
  ],
})
export class ProductOneCallComponent {
  faPhone = faPhone;
  @Input() tooltipPlacement: Placement = 'top';
  @Input() disabled: boolean;
}
